import React from 'react'
import {motion} from 'framer-motion'
export default function BannerImage() {
    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1 }}
            className='h-screen flex items-center w-[65%] 2xl:w-[70%] xl:pr-0 pr-7'
        >
            {/* <div className='h-screen flex items-center w-[65%] 2xl:w-[70%] xl:pr-0 pr-7'> */}
            <motion.img 
                loading='lazy'
                className='2xl:w-[90%] w-full h-fit'
                src={`/images/ARCM_login_banner.png`}
                alt="img" />
            {/* <img loading='lazy' decoding='async' src="/images/ARCM_login_banner.png" alt="Banner-Img" 
                    className='2xl:w-[90%] w-full h-fit' /> */}
            {/* </div> */}
        </motion.div>
    )
}
